// extracted by mini-css-extract-plugin
export default {"nav":"others_nav__QIf7j","active":"others_active__NjseB","indicator":"others_indicator__zJugW","profiles":"others_profiles__MeToo","chatPlaceholder":"others_chatPlaceholder__C0JyW"};